<script lang="ts">
  import ThumbsUpIcon from '$icons/ThumbsUpIcon.svelte';
  import { linkify, timeSince } from '$utils';
  import Avatar from '../images/Avatar.svelte';
  import RichTextRender from '../posts/RichTextRender.svelte';
  import NotificationTypeSymbol from './NotificationTypeSymbol.svelte';
  import NotificationSeenSetter from './NotificationSeenSetter.svelte';
  import { ContentType, ContentTypeDisplay } from '$shared/lib';
  import type { Notification } from '$shared/lib';
  import { handleNotificationClick } from '$lib/utils/notifications';

  export let notification: Notification;

  const link =
    notification.contentType === ContentType.POST
      ? `/posts/${notification.contentId}`
      : notification.contentType === ContentType.COMMENT
        ? `/posts/${notification.postId}/comments/${notification.contentId}`
        : notification.contentType === ContentType.HACKATHON_PROJECT
          ? `/projects/explore/${notification.urlSlug}`
          : notification.contentType === ContentType.PROJECT_COMMENT
            ? `/projects/explore/${notification.urlSlug}`
            : '';

  function onNotificationClick() {
    handleNotificationClick(notification);
  }
</script>

<a
  href={link}
  on:click={onNotificationClick}
  class:bg-mint-dark-1={!notification.isRead}
  class:border-mint-dark-6={!notification.isRead}
  class="border-gray-dark-4 relative flex w-full items-start gap-x-6 rounded border p-6"
>
  <NotificationTypeSymbol isRead={notification.isRead}>
    <ThumbsUpIcon class="text-gray-dark-12" />
  </NotificationTypeSymbol>

  <div class="flex-1 space-y-3 overflow-hidden">
    <div class="h-5 w-5">
      <Avatar
        src={notification?.interactingUsers?.[0].avatarUrl}
        seed={notification?.interactingUsers?.[0].username}
      />
    </div>

    <h2 class="text-base">
      {notification?.interactingUsers?.[0].displayName}
      {#if notification?.interactingUsers && notification?.interactingUsers?.length > 1}
        and {notification?.interactingUsers?.length - 1} others
      {/if} liked your {ContentTypeDisplay[notification.contentType].toLowerCase()}
    </h2>

    <div class="max-h-[60px] overflow-hidden shadow-inner">
      {#if typeof notification.contentBody === 'string' && !notification.contentBody.startsWith('{"type":"doc"')}
        <p class="whitespace-pre-wrap break-words">
          {@html linkify(notification.contentBody ?? '')}
        </p>
      {:else}
        {#key notification.contentBody}
          <div class="overflow-hidden whitespace-pre-wrap break-words">
            <RichTextRender content={notification.contentBody ?? ''} />
          </div>
        {/key}
      {/if}
    </div>

    <h3 class="text-gray-dark-11">
      {notification.createdAt && timeSince(new Date(notification.createdAt))}
    </h3>
  </div>
  {#if !notification.isRead}
    <NotificationSeenSetter bind:notificationId={notification.id} />
  {/if}
</a>
